exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login_base-material-card_portrait[data-v-0ef6a511]{padding:.85rem 1.42rem!important;width:80%!important;max-width:465px}.login_v-text-field[data-v-0ef6a511]{margin-top:2.85rem!important}.login_pages-btn_portrait[data-v-0ef6a511]{width:50%;margin-top:2.14rem;margin-bottom:1.42rem}.login_pages-btn_landscape[data-v-0ef6a511]{width:1rem!important;margin:0 2rem!important}", ""]);

// exports
